<div [class]="idn" style="width: 100%; height: 100%" #lineChartContainer [id]="idn"></div>
